export default __webpack_public_path__ + "static/3-bafd80a39ab45cda683a3fc76f6bae52.png";